import React from 'react';
import './ScaniaCustomModal.css';
var ScaniaCustomModal = function (_a) {
    var id = _a.id, title = _a.title, children = _a.children, actions = _a.actions, show = _a.show, handleClose = _a.handleClose, size = _a.size;
    return (React.createElement(React.Fragment, null, show && (React.createElement("div", { className: "sdds-modal-backdrop ".concat(show ? 'show' : '') },
        React.createElement("div", { id: id, className: "sdds-modal sdds-modal-".concat(!size ? "md" : size, "  customModal") },
            React.createElement("div", { className: "sdds-modal-header" },
                React.createElement("div", { className: "sdds-modal-headline" },
                    React.createElement("h5", null, title)),
                React.createElement("span", { className: "sdds-modal-btn", onClick: function () { return handleClose && handleClose(); }, onKeyPress: function () { return handleClose && handleClose(); }, tabIndex: 0, role: "button" })),
            React.createElement("div", { className: "sdds-modal-body modalBodyOveride" }, children),
            React.createElement("div", { className: "sdds-modal-actions sdds-modal-actions sdds-u-mb1 sdds-u-mt1" }, actions))))));
};
export default ScaniaCustomModal;
